import { render, staticRenderFns } from "./TransferOptionDialog.vue?vue&type=template&id=06965731&scoped=true"
import script from "./TransferOptionDialog.vue?vue&type=script&lang=js"
export * from "./TransferOptionDialog.vue?vue&type=script&lang=js"
import style0 from "./TransferOptionDialog.vue?vue&type=style&index=0&id=06965731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06965731",
  null
  
)

export default component.exports